



import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions } from '@ngrx/effects';
import { TranslateService } from '@ngx-translate/core';
import { AbstractEffects } from 'app/shared/utils/abstract-effects';
import { MessageService } from 'primeng/api';
import { StatutNotification } from './statut-notification.model';

@Injectable()
export class StatutNotificationEffects extends AbstractEffects {

    constructor(
        _actions$: Actions,
        _messageService: MessageService,
        _translateService: TranslateService,
		_router: Router) {
        super(StatutNotification, _actions$, _messageService, _router, _translateService, 'STATUTNOTIFICATION');
    }

}